var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 465,
    height: 1,
    viewBox: "0 0 465 1",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.688 0.259068C464.688 0.369651 360.813 0.45073 232.706 0.45073C104.599 0.45073 0.695068 0.369651 0.695068 0.259068C0.695068 0.148484 104.547 0.0673828 232.706 0.0673828C360.865 0.0673828 464.688 0.155857 464.688 0.259068Z",
    fill: "#06251E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.f44afcb1f4a4067fe2cb7d50a00e168f.svg";
export { ForwardRef as ReactComponent };